const ALLOWED_TAGS = new Set(["P", "H2", "H3", "H4", "H5", "UL", "OL", "LI", "A", "IMG", "STRONG", "B", "EM", "I", "U", "BR", "BLOCKQUOTE", "FIGURE", "FIGCAPTION", "TABLE", "THEAD", "TBODY", "TR", "TD", "TH"]);
const ALLOWED_ATTRS = { A: ["href", "target", "rel"], IMG: ["src", "alt", "loading"] };

export function sanitizeRichHtml(html) {
  const docu = new DOMParser().parseFromString(`<div>${html ?? ""}</div>`, "text/html");
  const walk = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType !== 1) return;
      if (!ALLOWED_TAGS.has(child.tagName)) {
        child.replaceWith(...child.childNodes);
        walk(node);
        return;
      }
      const keep = ALLOWED_ATTRS[child.tagName] || [];
      [...child.attributes].forEach((a) => {
        if (!keep.includes(a.name.toLowerCase())) child.removeAttribute(a.name);
      });
      if (child.tagName === "A") {
        const href = child.getAttribute("href") || "";
        if (/^\s*javascript:/i.test(href)) child.removeAttribute("href");
        else if (/^https?:/i.test(href)) {
          child.setAttribute("target", "_blank");
          child.setAttribute("rel", "noopener noreferrer");
        }
      }
      if (child.tagName === "IMG") child.setAttribute("loading", "lazy");
      walk(child);
    });
  };
  walk(docu.body);
  return docu.body.innerHTML;
}
